import ReactDom from "react-dom";
import ExploreTopicsTabs from "./ExploreTopicsTabs.jsx";

export default function renderExploreTopicsTabs() {
  document.querySelectorAll(".js-explore-topics-tabs").forEach((mount) => {
    const topics = JSON.parse(mount.getAttribute("data-topics"));
    const cardEyebrow = JSON.parse(mount.getAttribute("data-card-eyebrow"));
    const disabledLegend = JSON.parse(
      mount.getAttribute("data-disabled-legend"),
    );
    const exemplarsTitle = JSON.parse(
      mount.getAttribute("data-exemplars-title"),
    );

    ReactDom.render(
      <ExploreTopicsTabs
        topics={topics}
        cardEyebrow={cardEyebrow}
        disabledLegend={disabledLegend}
        exemplarsTitle={exemplarsTitle}
      />,
      mount,
    );
  });
}
